import React from "react";

const Kotlin_Syntax = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Syntax</h1>
      <p>Content for Kotlin Syntax goes here.</p>
    </div>
  );
};

export default Kotlin_Syntax;
